import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
    isSlimFooter: boolean = false;
    private routerSub: Subscription;

    constructor(private router: Router) {}

    ngOnInit(): void {
        this.checkRoute(this.router.url);
        this.routerSub = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.checkRoute(event.urlAfterRedirects || event.url);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSub) {
            this.routerSub.unsubscribe();
        }
    }

    private checkRoute(url: string): void {
        if (!url) return;
        const slimRoutes = [
            '/spekwo-products',
            '/products',
            '/sign-in',
            '/re-upload'
        ];
        this.isSlimFooter = slimRoutes.some(route => url.includes(route));
    }
}
